import { ApiError } from "./api";

/** Shared by the admin dashboard's panels, which all talk to the same API and
 * should all describe a refusal or a network fault the same way. */
export function errorMessage(error: unknown): string | null {
  if (!error) return null;
  if (error instanceof ApiError) return error.message;
  return "Could not reach the admin API. Check your connection and try again.";
}
